export default "__VITE_PUBLIC_ASSET__658798bc__"